import { React, useEffect, useState } from 'react';
import axios from 'axios';
import { NavLink, useNavigate } from 'react-router-dom';
import TableComponent from '../../admin/shared/table';
import LoaderComponent from '../../admin/shared/loader';
import { API_URL, PAGE_ROUTE } from '../shared/constant';

export default function TeamsListComponent() {

    let columns = [{
        field: 'name',
        lable: 'Name'
    }, {
        field: 'designation',
        lable: 'Designation'
    },
    {
        field: 'image',
        lable: 'Image'
    },
    {
        field: 'contact_no',
        lable: 'Contact-no'
    }, {
        field: 'bio_link',
        lable: 'Link'
    }
    ];

    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isRecall, setIsRecall] = useState(false);

    useEffect(() => {
        getTeams();
    }, []);

    useEffect(() => {
        isRecall && getTeams();
    }, [isRecall]);

    const getTeams = () => {
        setLoading(true);
        axios.post(API_URL.ADMIN_TEAMS_LIST, {}).then(res => {
            setData(res.data.data);
            setIsRecall(false);
            setLoading(false);
        }, error => {
            setLoading(false);
        })
    }

    const onDelete = (item) => {
        let id = item.id;
        axios.post(API_URL.ADMIN_TEAMS_DELETE + id).then((response) => {
            setIsRecall(true);
        });
    }

    const onEdit = (item) => {
        navigate(PAGE_ROUTE.ADMIN_TEAMS_EDIT + item.id, { replace: true });
    }


    return (
        <div>
            <div className='card'>
                <div className='card-body'>
                    <h4 className='card-title'>Teams
                        <NavLink to={PAGE_ROUTE.ADMIN_TEAMS_CREATE} className="btn btn-primary">
                            Add
                        </NavLink>
                    </h4>
                    {
                        isLoading && <LoaderComponent height={100} width={100}></LoaderComponent>
                    }
                    {
                        !isLoading && <div className="table-responsive">
                            <div className='table-responsive'>
                                <TableComponent
                                    columns={columns}
                                    data={data}
                                    onDelete={onDelete}
                                    onEdit={onEdit}>
                                </TableComponent>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
